import { FAQAccordion } from '../../../components/faq-accordion';
import { faqItems } from './LaasFaqContent';

const LaasFaq = () => (
    <section id="laas-faq" className="laas-faq">
        <div className="laas-faq-container">
            <div className="laas-faq-info-section">
                <h2 className="laas-faq-info-section-heading">Car shipping FAQs &amp; contact</h2>
                <div className="laas-faq-action">
                    <span className="laas-faq-icon faq-mail-icon">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M20 4H4a2 2 0 00-1.99 2L2 18c0 1.1.9 2 2 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                        </svg>
                    </span>
                    <a className="laas-faq-action-link" href="mailto:customer_shipping@carmax.com">
                        customer_shipping@carmax.com
                    </a>
                </div>
            </div>

            <FAQAccordion items={faqItems} />

            <br />
            <p>* Rate includes any applicable tax.</p>
        </div>
    </section>
);

export default LaasFaq;
